'use client';

import React from 'react';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CustomBackground from '@components/CustomBackground';
import AlGhadeerWelcome from '../AlGhadeerWelcome';
import AlGhadeerRegistration from '@components-launch/AlGhadeer/AlGhadeerRegistration';
import cn from './style.module.scss';
export default function AlGhadeerCommon(props: MarketingPageComponentProps) {
  return (
    <CustomBackground
      customClass={cn.alGhadeerCommonWrapper}
      bgImage={props.images.al_ghadeer_main_background?.src}
    >
      <AlGhadeerWelcome {...props} />
      <AlGhadeerRegistration {...props} />
    </CustomBackground>
  );
}
